import React from 'react';

const Skills = () => (
  <div className="Skills">
    <h3>Skills</h3>
    <h4>Programming language</h4>
    <ul>
      <li>Javascript (ES6), React (React, Redux, React-router, Immutable)</li>
      <li>Swift</li>
      <li>Ruby (Rails, RSpec)</li>
      <li>HTML</li>
      <li>CSS</li>
    </ul>

    <h4>Libraries</h4>
    <ul>
      <li>React (Redux, React-Router, Immutable)</li>
      <li>Mocha (Chai, Chai-as-promised)</li>
      <li>ESLint</li>
      <li>Webpack</li>
      <li>Rails</li>
      <li>RSpec</li>
      <li>jQuery</li>
      <li>Bootstrap (Foundation, Skeleton)</li>
    </ul>

    <h4>Platform</h4>
    <ul>
      <li>Browser</li>
      <li>Chrome extension</li>
      <li>Cli</li>
      <li>Server side</li>
      <li>iOS</li>
      <li>Digital Ocean, Linode</li>
      <li>AWS</li>
      <li>Firebase, Parse (self-hosted)</li>
    </ul>

    <h4>Tools</h4>
    <ul>
      <li>github</li>
      <li>JIRA</li>
      <li>Sketch</li>
      <li>Zeplin</li>
      <li>Affinity Photo</li>
    </ul>

    <h4>Natural language</h4>
    <ul>
      <li>Mandarin, native speaker</li>
      <li>Hakka</li>
      <li>Taiwanese Hokkien</li>
      <li>JLPT N1</li>
      <li>TOEFL 96</li>
    </ul>
  </div>
);

export default Skills;



// WEBPACK FOOTER //
// ./src/components/Skills/Skills.js